module.exports = __webpack_public_path__ + "static/media/Performance Tracking and Benchmarking.0b21471b.png";